import { useState, useEffect } from 'react';
import { Box, Flex, Text, Heading, Card, Avatar, Progress, HoverCard, TextField } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import UserAvatar from '../common/UserAvatar';
import { schoolService } from '../../services/school/schoolServices';
import { ChevronRightIcon, QuestionMarkCircledIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { useNavigate } from 'react-router-dom';

const SchoolTeacherSummaryView = ({ teachers, filter = false, onTeacherSelect = () => { } }) => {
  const schoolAdmin = useSelector((state) => state.schoolAdmin);
  const navigate = useNavigate();

  const renderMetrics = (metrics) => {
    console.log('metrics', metrics);
    const adherence = metrics.filter((metric) => metric.type === 'schedule_adherence');
    if (adherence.length == 0) {
      return <></>;
    }
    const adherence_avg = adherence.reduce((acc, curr) => acc + (curr.value ? curr.value : 0), 0) / adherence.length;
    return <Flex direction="row" gap="4" align="center">
      <Progress value={Math.round(adherence_avg)} />
      <Text size="1" as="p">{Math.round(adherence_avg)}%</Text>
    </Flex>;
  }

  return (
    <Box width="100%" maxWidth="1080px">
      <Card>
        <Flex direction="row" justify="between" align="center" mb="4">
          <Text size="2" weight="bold" as="p">Teachers</Text>
          <HoverCard.Root>
            <HoverCard.Trigger>
              <QuestionMarkCircledIcon />
            </HoverCard.Trigger>
            <HoverCard.Content>
              <Heading size="1">Teacher Summary</Heading>
              <Text size="1">
                All the teachers verified by the school admin with their performance according to their schedule adherence.
              </Text>
            </HoverCard.Content>
          </HoverCard.Root>
        </Flex>

        {teachers.length === 0 ? (
          <Flex direction="column" gap="4">
            <Heading size="2" color="gray">No teachers found</Heading>
            <Text size="1" color="gray">You need to verify the teachers to see their summary. Remind your teachers to request verification from their profile</Text>
          </Flex>
        ) : (
          <Flex direction="column" gap="4">
            {filter ? (
              <TextField.Root placeholder="Filter by name">
                <TextField.Slot>
                  <MagnifyingGlassIcon height="16" width="16" />
                </TextField.Slot>
              </TextField.Root>
            ) : (
              <></>
            )}
            {teachers.map((teacher) => (
              <Flex key={teacher.id} direction="row" align="center" justify="between" gap="4" className="cursor-pointer"
                onClick={() => onTeacherSelect(teacher)}
              >
                <Flex direction="row" align="center" gap="3" style={{ flex: 1, flexShrink: 0 }}>
                  <UserAvatar size="4" user={teacher.user} radius="large" />
                  <Flex direction="column" gap="2" style={{ flex: 1 }}>
                    <Text size="2" weight="bold">{teacher.user.firstname} {teacher.user.lastname}</Text>
                    {renderMetrics(teacher.performance_metrics)}
                  </Flex>
                </Flex>
                <ChevronRightIcon width="20" height="20" />
              </Flex>
            ))}
          </Flex>
        )}
      </Card>
    </Box>
  );
};

export default SchoolTeacherSummaryView;
